/**
 * 运营位数据获取工具函数
 * 从楼层数据中提取指定运营位的素材数据和扩展信息
 */

/**
 * 获取运营位素材数据
 * 从楼层的 position_info_list 中查找指定运营位，并提取其 material_list 数据
 *
 * @param {Object} floor_key_info - 楼层数据对象，包含 position_info_list 数组
 * @param {string} position_id - 运营位ID，如 'S_COOPERATION_INSTITUTION.F_TOP.P_BACKGROUND_IMAGE'
 * @param {string} key - 可选，若指定则返回 material_list[0][key] 的值
 * @param {boolean} needParse - 可选，若为 true 且结果为字符串，则进行 JSON.parse
 * @returns {Array|Object|string} 运营位的素材数据列表或指定字段值
 */
export function GetPosition (floor_key_info = {}, position_id, key, needParse) {
    // 获取楼层的运营位列表
    let list = floor_key_info?.position_info_list || []
    // 根据运营位ID查找对应的运营位
    let position = list?.find(item => item?.position_id === position_id) || {}
    // 获取运营位的素材列表
    let result = position?.material_list || []

    // 如果指定了 key，则返回素材列表第一个元素的对应字段值
    if (key) {
        result = position?.material_list?.[0]?.[key] || ''
    }

    // 如果需要解析且结果为字符串，则进行 JSON.parse
    if (needParse && result) {
        result = JSON.parse(result)
    }

    return result
}

/**
 * 获取运营位扩展信息
 * 从楼层的 position_info_list 中查找指定运营位，并提取其 extend_info
 *
 * @param {Object} floor_key_info - 楼层数据对象，包含 position_info_list 数组
 * @param {string} position_id - 运营位ID
 * @returns {Object} 运营位的扩展信息对象
 */
export function GetPositionExtInfo (floor_key_info, position_id) {
    let list = floor_key_info?.position_info_list || []
    let position = list?.find(item => item?.position_id === position_id) || {}
    return position.extend_info || {}
}